import { render, staticRenderFns } from "./NumberTemplate.vue?vue&type=template&id=79c854f6&scoped=true&"
import script from "./NumberTemplate.vue?vue&type=script&lang=js&"
export * from "./NumberTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c854f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c854f6')) {
      api.createRecord('79c854f6', component.options)
    } else {
      api.reload('79c854f6', component.options)
    }
    module.hot.accept("./NumberTemplate.vue?vue&type=template&id=79c854f6&scoped=true&", function () {
      api.rerender('79c854f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/NumberTemplate.vue"
export default component.exports